{
  "identity": {
    "title": "Identity"
  },
  "status": {
    "title": "Status"
  },
  "lastUpdate": {
    "title": "Last update"
  },
  "profile": {
    "title": "Profile"
  },
  "group": {
    "title": "Group"
  },
  "state": {
    "title": "State"
  },
  "name": {
    "title": "Name"
  },
  "operations": {
    "title": "Operations"
  },
  "connectionParameters": {
    "title": "Connection settings"
  },
  "specificParameters": {
    "title": "Specific parameters"
  },
  "roles": {
    "title": "Roles"
  }
}
